module.exports = __webpack_public_path__ + "static/img/jpcomma.57d6c6f5.png";